module.exports = __webpack_public_path__ + "static/media/image_6.bc8dfd14.png";